import React, { Component } from 'react';
import _ from 'lodash';

import { Fade } from 'ui/transition';

import { formData } from '../child-field';
import { IfProps } from '../fields';
import { isValue, renderChildren, getErrorsFromChildren } from 'ui/form/utils';

interface IfState {}

@formData
export default class If extends Component<IfProps, IfState> {
  static getErrors(props, formData) {
    const value = _.get(formData, props.field);
    if (If.shouldShow(props, value)) {
      return getErrorsFromChildren(props, formData);
    }
  
    return false;
  }
  
  static shouldShow(props, value): boolean {
    const { exists, func, is } = props;
    let show = true;
    if ('exists' in props) {
      if (_.isEqual(exists, true) && !(isValue(value) && value !== false)) show = false;
      if (_.isEqual(exists, false) && isValue(value) && value !== false) show = false;
    }
  
    if (show && 'is' in props) {
      if (typeof is === 'string') {
        const reg: RegExp = new RegExp('^' + is + '$');
        if (!reg.test(value)) show = false;
      } else {
        if (!_.isEqual(is, value)) show = false;
      }
    }
  
    if (show && func) {
      try {
        if (!func(value)) show = false;
      } catch (e) {
        /* In case the function fails */
        console.error('If func error', e);
      }
    }
    
    return show;
  }
  
  render() {
    const { children, field, formData } = this.props;
    if (!field) return <h3 className="text-error">Field name is required for IF fields</h3>;

    const value = _.get(formData, field);
    const show = If.shouldShow(this.props, value);
    const childList = show ?
      renderChildren(children, {
        handleChange: this.props.handleChange,
        props: this.props
      }) :
      null;
    
    return <Fade in={show}>{childList}</Fade>;
  }
}
